import React, { FC } from 'react';
import Typography from '@/components/atoms/typography';

interface Props {
  socialMedia?: any;
  copyright?: any;
}

const FooterBottom: FC<Props> = ({ copyright }) => {

  return (
    <>
      <div className="hidden items-center justify-between md:flex">
        <Typography className=" font-medium text-white text-[13px]">
          {copyright}
        </Typography>{' '}
      </div>
      <div className=" flex flex-col items-start md:hidden ">
        <Typography className="text-500 pb-4 text-[13px] font-medium text-[#FFFFFF] md:text-[13px]">
          {copyright}
        </Typography>
      </div>
    </>
  );
};

export default FooterBottom;
